module.exports = __webpack_public_path__ + "media/images/adoption/adoption8-92f8fe644331a1e39ccdbe5e47d0596c.jpg";